import React from 'react';
import { block } from '../../utils/cn';
import i18n from './i18n';
import './ErrorMessage.css';
import { jsxs as _jsxs } from "react/jsx-runtime";
var b = block('error-message');
export function ErrorMessage(_ref) {
  var message = _ref.message,
    className = _ref.className;
  return /*#__PURE__*/_jsxs("div", {
    className: b(null, className),
    children: [i18n('default_message'), message && ": ".concat(message)]
  });
}
// #sourceMappingURL=ErrorMessage.js.map